var KeyCode = {
  ENTER: 13,
  ESC: 27
};
export default KeyCode;